import client from "../client";
import { EvaluationCriteriaInterface } from "../../models/ProcurementModule/EvaluationCriteria";

const listName = "RfpEvaluationCriterias";

class EvaluationCriteria {
  async GetAll(page: number, pageSize: number) {
    try {
      const { data } = await client.post<EvaluationCriteriaInterface[]>(
        `/api/${listName}/get`,
        {
          page,
          pageSize,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<EvaluationCriteriaInterface>(
        `/api/${listName}/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(item: EvaluationCriteriaInterface) {
    try {
      const { data } = await client.post<EvaluationCriteriaInterface>(
        `/api/${listName}/create`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, item: EvaluationCriteriaInterface) {
    try {
      const { data } = await client.post<EvaluationCriteriaInterface>(
        `/api/${listName}/update/${id}`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<EvaluationCriteriaInterface>(
        `/api/${listName}/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new EvaluationCriteria();
